import 'cordova-plugin-purchase';
import {
  isApprovedWatchDutyTransaction,
  isPreCheckoutSubscriptionTransaction,
} from '../detectIapCollision';

export type ReconcileCriteria = {
  productId: string;
  checkoutStartedAt: number;
};

const transactionHasProduct = (
  transaction: CdvPurchase.Transaction,
  productId: string,
): boolean => Boolean(transaction.products?.some((p) => p.id === productId));

/**
 * Finds the approved-but-unfinished transaction for the interrupted checkout described
 * by `criteria`, or `null` if there isn't one.
 */
export const findReconcilableTransaction = (
  transactions: CdvPurchase.Transaction[],
  criteria: ReconcileCriteria,
): CdvPurchase.Transaction | null =>
  transactions?.find(
    (transaction) =>
      isApprovedWatchDutyTransaction(transaction) &&
      !isPreCheckoutSubscriptionTransaction(
        transaction,
        criteria.checkoutStartedAt,
      ) &&
      transactionHasProduct(transaction, criteria.productId),
  ) ?? null;
